export const websocketConstants = {
    WS_CONNECT : "WS_CONNECT",
    WS_DISCONNECT : "WS_DISCONNECT",
};
